import React from 'react';
import Checkbox from 'components/atoms/checkbox';
import MonitoringPrioritySelect from 'components/atoms/monitoring_priority_select';
import ToggleSwitch from 'components/atoms/toggle_switch';
import {
  KEYWORD_CHANNELS,
  MONITORING_CHANNELS,
  MonitoringChannel,
  MonitoringPriority,
  MonitoringRule,
} from 'services/monitoring_settings';

interface MonitoringRuleRowProps {
  rule: MonitoringRule;
  onPriority: (priority: MonitoringPriority) => void;
  onChannel: (channel: MonitoringChannel) => void;
  onActive: () => void;
  onRemove: (() => void) | null;
}

const MonitoringRuleRow = ({
  rule,
  onPriority,
  onChannel,
  onActive,
  onRemove,
}: MonitoringRuleRowProps) => (
  <tr>
    <td className="rule-label">{rule.label}</td>
    <td>
      <MonitoringPrioritySelect
        value={rule.priority}
        label={`Nível de prioridade de ${rule.label}`}
        disabled={false}
        onChange={onPriority}
      />
    </td>
    <td>
      <div
        className="d-flex flex-wrap align-items-center"
        role="group"
        aria-label={`Avisos de ${rule.label}`}
      >
        {MONITORING_CHANNELS.map((channel) =>
          rule.keywordId !== null && !KEYWORD_CHANNELS.includes(channel.value) ? (
            <span className={`rule-channel rule-channel-${channel.value}`} key={channel.value} />
          ) : (
            <span
              className={`rule-channel rule-channel-${channel.value} d-inline-flex align-items-center`}
              key={channel.value}
            >
              <Checkbox
                customClass="m-0"
                label={channel.label}
                checked={rule.channels[channel.value]}
                disabled={false}
                handleChange={() => onChannel(channel.value)}
              />
              {channel.help && (
                <span
                  className="ml-1 databalloon monitoring-help-mark d-inline-block rounded-circle bg-primary text-white"
                  data-balloon-length="large"
                  aria-label={channel.help}
                  data-balloon-pos="up"
                >
                  <i className="oi oi-question-mark" />
                </span>
              )}
            </span>
          ),
        )}
      </div>
    </td>
    <td>
      <ToggleSwitch
        checked={rule.active}
        label={`Monitorar ${rule.label}`}
        disabled={false}
        onChange={onActive}
      />
    </td>
    <td className="rule-remove">
      {onRemove && (
        <button
          type="button"
          className="btn btn-link p-0"
          aria-label={`Excluir a palavra-chave ${rule.label}`}
          title="Excluir palavra-chave"
          onClick={onRemove}
        >
          <i className="material-icons align-middle">delete</i>
        </button>
      )}
    </td>
  </tr>
);

export default MonitoringRuleRow;
